__turbopack_context__.v({
  "profile-photo-dialog-content": "jd51gq_profile-photo-dialog-content",
  "profile-photo-dialog-content__error-message": "jd51gq_profile-photo-dialog-content__error-message",
  "profile-photo-dialog-content__paragraph": "jd51gq_profile-photo-dialog-content__paragraph",
  "profile-photo-dialog-content__photo": "jd51gq_profile-photo-dialog-content__photo",
  "profile-photo-dialog-content__photo-container": "jd51gq_profile-photo-dialog-content__photo-container",
  "profile-photo-dialog-content__picture-requirements": "jd51gq_profile-photo-dialog-content__picture-requirements",
});
